import React from "react";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

export const Image = ({ title, smallImage, text, id, slug, category, industry, platform }) => {
  return (
    <div className="portfolio-item">
      <Link
        to={`/case-studies/${slug || id}`}
        title={title}
        onClick={() => scroll.scrollToTop()}
        className="cs-card"
      >
        <div className="cs-card-media">
          <img src={smallImage} alt={title} loading="lazy" decoding="async" />
        </div>
        <div className="cs-card-body">
          <h4 className="cs-card-title">{title}</h4>
          {category && <span className="cs-card-category">{category}</span>}
          <p className="cs-card-text">{text}</p>
          <div className="cs-card-tags">
            {industry && <span className="tag">{industry}</span>}
            {platform && <span className="tag">{platform}</span>}
          </div>
          <span className="cs-card-cta">View Case Study →</span>
        </div>
      </Link>
    </div>
  );
};
